import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { privilegeFetch, privilegeFetchDesc } from '../redux/actions'

class Pointdetail extends Component {

    constructor() {
        super()
        this.state = {
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        this.props.privilegeFetch()
        this.props.privilegeFetchDesc()
    }

    showPrivilege() {
        if(this.props.privileges) {
            return this.props.privileges.map((item, index) => {
                return (
                    <div className="each-pointdetail" key={++index}>
                        <div className="pointdetail-left">
                            <img src={item.img} alt="apspoint"/>
                        </div>
                        <div className="pointdetail-right">
                            <h2 className="pointdetail-title">{item.title}</h2>
                            <div className="pointdetail-point">
                                <div className="gift"><img src={require("../static/images/02_profile/gift.png")} alt="apsgift"/></div>
                                <h2><span className="point">{item.point}</span>&nbsp;คะแนน</h2>
                            </div>
                        </div>
                    </div>
                )
            })
        } else {
            return <Loader />
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-pointdetail">
                <Analytics />
                <div className="pointdetail-header">
                    <Backbtn />
                    <div className="title">
                        <p>สิทธิพิเศษ</p>
                    </div>
                    <Nav />
                </div>
                <div className="point-condition container">
                    <h3>เกณฑ์ในการสะสมคะแนน</h3>
                    <p>{this.props.desc}</p>
                </div>
                <div className="pointdetail-list container">
                    {this.showPrivilege()}
                </div>
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ privilege }) => {
    return { 
        privileges: privilege.privileges,
        desc: privilege.desc
    }
}
 
export default connect(mapStateToProps, { privilegeFetch, privilegeFetchDesc })(Pointdetail);